import * as React from "react";
import { UserAuthenticationContextType, UserAuthenticationContext } from "../context/UserAuthentication";

export const useAuth = (): UserAuthenticationContextType => {
  return React.useContext(UserAuthenticationContext);
}